export default function ShareIcon() {
  return (
    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.836 16.13L9.026 12.2l-.75 1.299 6.81 3.932.75-1.3zM15.836 7.866l-6.81 3.932-.75-1.3 6.81-3.931.75 1.299z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M17.85 9.15a3.15 3.15 0 100-6.3 3.15 3.15 0 000 6.3zM9.3 11.994a3.15 3.15 0 11-6.3 0 3.15 3.15 0 016.3 0zM21 17.996a3.15 3.15 0 10-6.3 0 3.15 3.15 0 006.3 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}
